import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Pencil } from "lucide-react";

export function ProfileEditor() {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: user?.name || "", phone: user?.phone || "" });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/auth/profile", f);
      setUser({ ...user, ...r.data });
      toast.success("Profile updated"); setOpen(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <>
      <Button variant="outline" onClick={() => { setF({ name: user?.name || "", phone: user?.phone || "" }); setOpen(true); }} className="rounded-full" data-testid="edit-profile"><Pencil className="w-4 h-4 mr-1"/>Edit Profile</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Edit Profile</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Name</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="profile-name"/></div>
            <div><Label>Phone</Label><Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="(555) 555-5555" data-testid="profile-phone"/></div>
            <Button onClick={save} disabled={saving} className="w-full rounded-full bg-[hsl(var(--primary))]" data-testid="profile-save">{saving ? "Saving…" : "Save"}</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
